export const environment = {
  authentication_type: "student",
  name: "PROD",
  production: true,
  url: "/planapp/osiris/v1",
};
